import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../resources/helper/helper";
import {
  getAllProducts,
  getCategoryWiseProducts,
} from "../redux/features/productSlice";
import { toast } from "react-toastify";

const CategoriesSideBar = () => {
  const { categories } = useSelector((state) => state.category);
  const dispatch = useDispatch();
  const token = getToken();
  const handleCategoryWiseProduct = (category) => {
    const payload = {
      token,
      category,
    };
    dispatch(getCategoryWiseProducts(payload))
      .unwrap()
      .then((res) => {
        console.log("Get category wise products", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  };

  const handleAllProducts = () => {
    dispatch(getAllProducts(token))
      .unwrap()
      .then((res) => {
        console.log("Get Products from category Sidebar", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  };
  return (
    <div className="col-2 d-none d-lg-flex">
      <div
        className="categories-dropdown-wrap style-2 font-heading"
        style={{
          height: 600,
          overflowY: "auto",
          padding: "10px 10px 10px 12px",
        }}
      >
        <h4 className="mb-20">Categories</h4>
        <div className="d-flex">
          {categories && categories?.length > 0 && (
            <ul>
              <li onClick={handleAllProducts}>
                <h2
                  className="categoryHeading"
                  style={{
                    fontSize: "16px",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 5,
                  }}
                >
                  <div
                    style={{
                      width: "4px",
                      height: "4px",
                      borderRadius: 50,
                      backgroundColor: "grey",
                      marginTop: "8px",
                    }}
                  />
                  <a className="categoryHeading">All</a>
                </h2>
              </li>
              {categories?.map((item, index) => (
                <li
                  key={index}
                  onClick={() => handleCategoryWiseProduct(item?.label)}
                >
                  <h2
                    className="categoryHeading"
                    style={{
                      marginBottom: "20px",
                      fontSize: "16px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      gap: 5,
                    }}
                  >
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        borderRadius: 50,
                        backgroundColor: "grey",
                        marginTop: "8px",
                      }}
                    />
                    <a
                      className="categoryHeading"
                      style={{ lineHeight: "18px" }}
                    >
                      {item?.label}
                    </a>
                  </h2>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="more_slide_open" style={{ display: "none" }}>
          <div className="d-flex categori-dropdown-inner">
            {categories && categories?.length > 0 && (
              <ul>
                <li onClick={handleAllProducts}>
                  <h2 className="categoryHeading" style={{ fontSize: "16px" }}>
                    <a className="categoryHeading">All</a>
                  </h2>
                </li>
                {categories?.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleCategoryWiseProduct(item?.label)}
                  >
                    <h2
                      className="categoryHeading"
                      style={{ marginBottom: "10px", fontSize: "16px" }}
                    >
                      <a className="categoryHeading">{item?.label}</a>
                    </h2>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesSideBar;
